import axios from 'axios'

import { ENV } from '../initialization'
// import { putToS3, removeExifDataImage } from '../utils'
import {
  FilterQuery,
  ImportExcelVendorResponseDto,
  ListVendorInfoResponseDto,
  NewVendorRequestBodyDto,
  OperatingTime,
  UploadUrlDto,
  VendorInfoDto
} from '../definition'
import { putToS3 } from '../utils'
import { toast } from 'react-toastify'

const DOMAIN = ENV.BACKEND_PREFIX_URL

export const asyncGetListVendors = async (data: FilterQuery): Promise<ListVendorInfoResponseDto | undefined> => {
  const url = `${DOMAIN}/api/authentication/profile/vendor`
  const response = await axios.get<ListVendorInfoResponseDto>(url, {
    params: data
  })
  return response.data
}

export const asyncCreateVendor = async (data: NewVendorRequestBodyDto): Promise<any | undefined> => {
  const url = `${DOMAIN}/api/authentication/profile/vendor`
  const rtData = await axios.post(url, data)
  return rtData.data
}

export const asyncGetVendorDetail = async (id: string): Promise<VendorInfoDto | undefined> => {
  const url = `${DOMAIN}/api/authentication/profile/vendor/${id}`
  const response = await axios.get(url)
  return response.data
}

export const asyncSaveVendor = async (id: string, data: any): Promise<void> => {
  const url = `${DOMAIN}/api/authentication/profile/vendor/${id}`
  await axios.put(url, data)
}

export const uploadProof = async (avatarFile: File, customerId?: string, avatarFileId?: string) => {
  const url = `${DOMAIN}/api/authentication/profile/get-upload-url`
  const getUrlResponse = await axios.post<UploadUrlDto>(url, {
    fileName: avatarFile.name,
    fileId: avatarFileId,
    ownerId: customerId,
    dataType: 'avatar'
  })
  await putToS3(avatarFile, getUrlResponse.data.preSignUrl)
  return getUrlResponse.data
}

export const asyncActiveVendor = async (id: string): Promise<void> => {
  const url = `${DOMAIN}/api/authentication/profile/vendor/active/${id}`
  await axios.put(url)
}

export const asyncDeactiveVendor = async (id: string): Promise<void> => {
  const url = `${DOMAIN}/api/authentication/profile/vendor/deactive/${id}`
  await axios.put(url)
}

export const asyncImportExcelVendor = async (file: File): Promise<ImportExcelVendorResponseDto | undefined> => {
  const url = `${DOMAIN}/api/authentication/profile/vendor/add-vendors-from-excel`
  let bodyFormData = new FormData()
  bodyFormData.append('file', file)

  try {
    const res = await axios({
      method: 'post',
      url: url,
      data: bodyFormData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })

    return res.data
  } catch (error: any) {
    const errMsg = error.response?.data?.error?.message || error.message
    toast.error(errMsg)
  }
}

export const asyncUpdateVendorOperating = async (id: string, operatingTime: OperatingTime[]): Promise<void> => {
  const url = `${DOMAIN}/api/authentication/profile/vendor/update-operating-time/${id}`
  await axios.put(url, { operatingTime: operatingTime })
}

export const asyncGetVendorAvailability = async (mainCategoryId: string, monthYear: string): Promise<string[]> => {
  const url = `${DOMAIN}/api/booking/booking/get-vendor-availability`
  const response = await axios.get(url, {
    params: { mainCategoryId, monthYear }
  })
  return response.data
}
